module.exports = __webpack_public_path__ + "img/07.4fc89bbb.jpg";